import { Component, OnInit } from "@angular/core";
import { ICustomer } from "src/app/Models/ICustomer";
import { BaseService } from "src/app/Services/Base.service";
declare var $: any;

@Component({
  selector: "app-customer",
  templateUrl: "./customer.component.html",
  styleUrls: ["./customer.component.scss"]
})
export class CustomerComponent implements OnInit {
  lang: string;
  url: string;
  data: Array<ICustomer>;

  constructor(private base: BaseService) {
    this.url = this.base.url;
    this.data = new Array<ICustomer>();
  }

  ngOnInit() {
    this.lang = this.base.getLang();

    this.data.push({
      title: { ar: "بيناكل", en: "Pinical" },
      image: "assets/images/Customer/p.svg",
      isActive: true
    });

    this.data.push({
      title: { en: "MTN Sudan", ar: "MTN Sudan" },
      isActive: true,
      image: "assets/images/Partiner/MTN_Logo.svg"
    });

    this.data.push({
      title: {
        en: "TAWEEL STAR FACTORY FOR JUICES & CHIPS",
        ar: "مصنع الطويل للنجوم والعصائر"
      },
      isActive: true,
      image: "assets/images/Customer/c1.png"
    });

    this.data.push({
      title: { en: "BLACK & WHITE", ar: "BLACK & WHITE" },
      isActive: true,
      image: "assets/images/Customer/c2.png"
    });

    this.data.push({
      title: { en: "DAMBA MALL", ar: "دامبا مول" },
      isActive: true,
      image: "assets/images/Customer/c3.png"
    });

    // this.data.push({
    //   title: { en: "5TH AVENUE", ar: "فيفس افينيو" },
    //   isActive: true,
    //   image: "assets/images/Customer/c4.png"
    // });

    // this.data.push({
    //   title: { en: "GIDA", ar: "جياد" },
    //   isActive: true,
    //   image: "assets/images/Customer/c5.png"
    // });

    if (this.data.length > 0) {
      $(document).ready(function() {
        $(".customer-logos").slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          rtl: true,
          autoplay: true,
          autoplaySpeed: 1500,
          lazyLoad: "progressive",
          arrows: false,
          dots: true,
          centerMode: true,
          centerPadding: "60px",
          pauseOnHover: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 1
              }
            }
          ]
        });
      });
    } else {
      $(".customer").hide();
    }
  }

  ngAfterViewInit() {}

  ngAfterContentChecked() {
    this.lang = this.base.getLang();
    if (this.lang == "en") {
      $(
        ".slick-prev, .slick-next, .slick-dots, .slick-dots li button:before"
      ).css("direction", " ltr");
    } else {
      $(".slick-dots, .slick-dots li button:before").css("direction", " rtl");
    }
  }

  onLoading(id) {
    $("." + id).fadeOut("slow");
  }
}
